// 登入彈窗是全站共用的一扇門：頁首的「網路票選登入」會開它，
// 之後投票、問答流程遇到未登入也會開同一扇，所以開關狀態放共用的 useState，
// 不掛在任何一頁上；彈窗本體由 SiteHeader 一併帶出，每頁只會有一個。
export function useLoginDialog() {
  const isLoginOpen = useState('login_dialog_open', () => false)
  const loginRedirect = useState('login_dialog_redirect', () => '')

  /**
   * 開啟登入彈窗
   * @param {string} redirect 登入完成後要回到的站內路徑，不給就回到當下這一頁
   */
  function openLogin(redirect = '') {
    loginRedirect.value = redirect
    isLoginOpen.value = true
  }

  function closeLogin() {
    isLoginOpen.value = false
  }

  return { isLoginOpen, loginRedirect, openLogin, closeLogin }
}
